/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchDisputeResolutionDetail } from './MatchDisputeResolutionDetail';
import {
    MatchDisputeResolutionDetailFromJSON,
    MatchDisputeResolutionDetailFromJSONTyped,
    MatchDisputeResolutionDetailToJSON,
    MatchDisputeResolutionDetailToJSONTyped,
} from './MatchDisputeResolutionDetail';

/**
 * 
 * @export
 * @interface MatchDisputeResponse
 */
export interface MatchDisputeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MatchDisputeResponse
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeResponse
     */
    raisedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchDisputeResponse
     */
    raisedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeResponse
     */
    reason?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatchDisputeResponse
     */
    evidence: Array<string>;
    /**
     * 
     * @type {MatchDisputeResolutionDetail}
     * @memberof MatchDisputeResponse
     */
    resolution?: MatchDisputeResolutionDetail;
    /**
     * 
     * @type {string}
     * @memberof MatchDisputeResponse
     */
    chatChannelId?: string;
}

/**
 * Check if a given object implements the MatchDisputeResponse interface.
 */
export function instanceOfMatchDisputeResponse(value: object): value is MatchDisputeResponse {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('evidence' in value) || value['evidence'] === undefined) return false;
    return true;
}

export function MatchDisputeResponseFromJSON(json: any): MatchDisputeResponse {
    return MatchDisputeResponseFromJSONTyped(json, false);
}

export function MatchDisputeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchDisputeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
        'raisedBy': json['raisedBy'] == null ? undefined : json['raisedBy'],
        'raisedAt': json['raisedAt'] == null ? undefined : json['raisedAt'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'evidence': json['evidence'],
        'resolution': json['resolution'] == null ? undefined : MatchDisputeResolutionDetailFromJSON(json['resolution']),
        'chatChannelId': json['chatChannelId'] == null ? undefined : json['chatChannelId'],
    };
}

export function MatchDisputeResponseToJSON(json: any): MatchDisputeResponse {
    return MatchDisputeResponseToJSONTyped(json, false);
}

export function MatchDisputeResponseToJSONTyped(value?: MatchDisputeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'raisedBy': value['raisedBy'],
        'raisedAt': value['raisedAt'],
        'reason': value['reason'],
        'evidence': value['evidence'],
        'resolution': MatchDisputeResolutionDetailToJSON(value['resolution']),
        'chatChannelId': value['chatChannelId'],
    };
}

